<template>
	<div>
		<div>欢迎进入</div>
		<div>家属用电预付费</div>
	</div>
</template>

<script>
	export default {
		name: "Index",
	}
</script>

<style scoped>



</style>